module.exports = __webpack_public_path__ + "static/media/economic.b1421dd8.svg";